import { Button } from "@/components/ui/button";
import MetallicPaint from "@/components/MetallicPaint";
import { useEffect, useMemo } from "react";

type NotFoundProps = {
  onNavigate?: (path: string) => void;
};

function svgTextDataUrl(text: string) {
  const svg = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="600" viewBox="0 0 1200 600">
  <rect width="100%" height="100%" fill="transparent"/>
  <text x="50%" y="52%" text-anchor="middle" dominant-baseline="middle"
    font-family="Georgia, 'Times New Roman', 'Yu Mincho', 'Hiragino Mincho ProN', serif"
    font-size="520" font-weight="300" fill="#000000" letter-spacing="-22">
    ${text}
  </text>
</svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

export function NotFound({ onNavigate }: NotFoundProps) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "404 | モノバンドル株式会社";

    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);

    return () => {
      document.title = prevTitle;
      meta.remove();
    };
  }, []);

  const metallic404 = useMemo(() => svgTextDataUrl("404"), []);

  const go = (path: string) => {
    if (onNavigate) onNavigate(path);
    else if (typeof window !== "undefined") {
      window.history.pushState({}, "", path);
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  };

  return (
    <section className="flex min-h-[70vh] flex-col items-center justify-center px-6 py-24 text-center">
      <div className="relative h-[180px] w-[380px] md:h-[240px] md:w-[520px]">
        <MetallicPaint
          imageSrc={metallic404}
          // subtle, readable metallic (logoよりも落ち着いたトーン)
          brightness={1.8}
          contrast={0.65}
          scale={3.6}
          refraction={0.01}
          blur={0.012}
          liquid={0.55}
          speed={0.25}
          fresnel={1.05}
          lightColor="#f5f5f5"
          darkColor="#0b0b0b"
          tintColor="#e7d7ff"
          chromaticSpread={1.4}
          distortion={0.9}
          contour={0.22}
          mouseAnimation={false}
        />
      </div>
      <h1 className="mt-4 font-serif text-2xl font-light text-foreground md:text-3xl">
        ページが見つかりません
      </h1>
      <p className="mt-3 max-w-md text-sm text-muted-foreground">
        お探しのページは存在しないか、移動した可能性があります。
      </p>
      <Button
        variant="default"
        size="lg"
        className="mt-10 min-w-[160px]"
        onClick={() => go("/")}
      >
        トップへ戻る
      </Button>
    </section>
  );
}
